// extracted by mini-css-extract-plugin
export var displayNone = "_od-6";
export var imgContainer = "_od-2";
export var overflowHidden = "_od-3";
export var productInfoCardButtonContainer = "_od-5";
export var productTitleText = "_od-4";
export var rightArrow = "_od-1";
export var rightArrowContainer = "_od-0";